import React from 'react';
import { ExclamationTriangleIcon } from '../../icons';
import { isTranscriptCertified } from '../../utils/transcriptCertification';

const DraftBanner = ({ transcription, compact = false }) => {
  if (!transcription || isTranscriptCertified(transcription)) return null;

  if (transcription.is_regenerated) {
    return (
      <div className={`draft-banner ${compact ? 'draft-banner-compact' : ''}`}>
        <ExclamationTriangleIcon className="h-5 w-5 flex-shrink-0" />
        <div>
          <p className="font-semibold">Regenerated transcript — Draft</p>
          {!compact && (
            <p className="text-sm mt-0.5 opacity-90">
              This language version requires independent certification before it can be used as an official record.
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={`draft-banner ${compact ? 'draft-banner-compact' : ''}`}>
      <ExclamationTriangleIcon className="h-5 w-5 flex-shrink-0" />
      <div>
        <p className="font-semibold">AI Draft — Not certified</p>
        {!compact && (
          <p className="text-sm mt-0.5 opacity-90">
            Review against the original audio, make corrections, then certify to mark this as the official court record.
          </p>
        )}
      </div>
    </div>
  );
};

export default DraftBanner;
